// External Imports
import { Axios, AxiosResponse } from "axios";

// Internal Imports
import { addUrlQuery } from "../utils";
import { Query } from "../types/query";

export interface PagesInterface {
  getAll: (query?: Query) => Promise<any>;
}

export const pages = (client: Axios): PagesInterface => ({
  getAll: async (query?: Query) => {
    const url = addUrlQuery(`/pages`, query);
    const { data }: AxiosResponse = await client.get(url);
    return data;
  }
});
